import { useEffect, useState } from "react";

// Mobile breakpoint mirrors the design system's `--bp-md` (768px): at and below this
// width the workspace switches from the three-pane desktop grid to the PWA app shell
// (top bar + scrollable content + bottom tab bar). The `/app` route is `ssr: false`,
// so `window.matchMedia` is available at mount with no hydration mismatch; we still
// default to `false` so any non-DOM render path stays on the desktop layout.
const MOBILE_QUERY = "(max-width: 767px)";

export function useWorkspaceMediaQuery(mediaQuery: string): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return false;
    }
    return window.matchMedia(mediaQuery).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const query = window.matchMedia(mediaQuery);
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    // Sync immediately in case the match changed between initial state and effect.
    setIsMobile(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, [mediaQuery]);

  return isMobile;
}

export function useIsMobile(): boolean {
  return useWorkspaceMediaQuery(MOBILE_QUERY);
}
